import React from 'react';
import { Helmet } from 'react-helmet';
import { withCustomContexts } from '../../../shared/components/Contexts';
import { createSchedulingSessionStateLandingPage } from '../../../shared/components/SchedulingSessionState';
import { WIDGET_CHROME } from '../../../shared/constants';
import { ITrackerData, IWidgetSettings } from '../../../types';
import OfficeListMapV1 from '../../components/OfficeListMapV1';
import WidgetLayout from '../../components/WidgetLayout';
import WidgetPracticeHeader from '../../components/WidgetPracticeHeader';
import WidgetSessionOpenedMutation from '../../components/WidgetSessionOpenedMutation';
import NotFoundPage from '../NotFoundPage';
import { Practice } from './types';

interface PracticePageProps {
  practice: Practice | null;
  widgetSettings: IWidgetSettings;
  trackerData: ITrackerData;
}

function PracticePage({ practice, trackerData, widgetSettings: { chrome } }: PracticePageProps) {
  if (!practice) return <NotFoundPage />;
  return (
    <WidgetLayout
      header={<WidgetPracticeHeader practice={practice} />}
      isEmbedded={chrome === WIDGET_CHROME.EMBEDDED}
    >
      <Helmet>
        <title>{practice.display}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <WidgetSessionOpenedMutation widgetId={trackerData?.widgetId} />
      <OfficeListMapV1 offices={practice?.offices.nodes} practiceId={practice.id} />
    </WidgetLayout>
  );
}

export default createSchedulingSessionStateLandingPage(withCustomContexts(PracticePage));
